module.exports = __webpack_public_path__ + "img/online-step-4.3f3a740e.png";